/* import __COLOCATED_TEMPLATE__ from './seller-posting-not-validated.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

class SellerPostingNotValidatedComponent extends Component {
  @service session;

  get slug() {
    return this.session.currentUser.slug;
  }

  get isUserAwaitingVetting() {
    const { currentUser } = this.session;
    return currentUser.isVettable || currentUser.isAwaitingVettable;
  }
}

export default SellerPostingNotValidatedComponent;
